const SIDEBAR_COLLAPSED_WIDTH = 56;
const SIDEBAR_MIN_EXPANDED = 160;
const SIDEBAR_MAX = 360;
const SIDEBAR_DEFAULT = 200;
const SIDEBAR_COLLAPSE_DRAG_THRESHOLD = 100;

const STORAGE_WIDTH = "weektodo.desktopSidebarWidth";
const STORAGE_COLLAPSED = "weektodo.desktopSidebarCollapsed";

function clampSidebarWidth(width) {
  const n = Number(width);
  if (!Number.isFinite(n)) return SIDEBAR_DEFAULT;
  return Math.min(SIDEBAR_MAX, Math.max(SIDEBAR_MIN_EXPANDED, Math.round(n)));
}

function sidebarDisplayWidth(width, collapsed) {
  return collapsed ? SIDEBAR_COLLAPSED_WIDTH : clampSidebarWidth(width);
}

function shouldCollapseFromDrag(width) {
  return Number(width) < SIDEBAR_COLLAPSE_DRAG_THRESHOLD;
}

function loadSidebarPrefs(storage) {
  if (!storage || typeof storage.getItem !== "function") {
    return { width: SIDEBAR_DEFAULT, collapsed: false };
  }
  const width = clampSidebarWidth(storage.getItem(STORAGE_WIDTH) || SIDEBAR_DEFAULT);
  const collapsed = storage.getItem(STORAGE_COLLAPSED) === "1";
  return { width, collapsed };
}

function saveSidebarPrefs(storage, { width, collapsed }) {
  if (!storage || typeof storage.setItem !== "function") return;
  storage.setItem(STORAGE_WIDTH, String(clampSidebarWidth(width)));
  storage.setItem(STORAGE_COLLAPSED, collapsed ? "1" : "0");
}

module.exports = {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_MIN_EXPANDED,
  SIDEBAR_MAX,
  SIDEBAR_DEFAULT,
  SIDEBAR_COLLAPSE_DRAG_THRESHOLD,
  STORAGE_WIDTH,
  STORAGE_COLLAPSED,
  clampSidebarWidth,
  sidebarDisplayWidth,
  shouldCollapseFromDrag,
  loadSidebarPrefs,
  saveSidebarPrefs,
};
